// src/pages/Landing/index.jsx
import { useTheme, useMediaQuery } from "@mui/material";
import LandingDesktop from "./LandingDesktop";
import LandingMobile from "./LandingMobile";

export default function Landing() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return isMobile ? <LandingMobile /> : <LandingDesktop />;
}
